import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Alert,
  Snackbar,
  Stack,
  IconButton,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { RootState } from '../store';
import { removeToast } from '../store/slices/toastSlice';
import { Toast } from '../store/slices/toastSlice';

const ToastContainer = () => {
  const dispatch = useDispatch();
  const { toasts } = useSelector((state: RootState) => state.toast);

  const handleClose = (id: string) => {
    dispatch(removeToast(id));
  };

  return (
    <Stack spacing={1} sx={{ position: 'fixed', top: 20, right: 20, zIndex: 9999 }}>
      {toasts.map((toast: Toast) => (
        <Snackbar
          key={toast.id}
          open={true}
          autoHideDuration={toast.duration || 5000}
          onClose={() => handleClose(toast.id)}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Alert
            severity={toast.type}
            onClose={() => handleClose(toast.id)}
            action={
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => handleClose(toast.id)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
            sx={{ minWidth: '300px' }}
          >
            {toast.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default ToastContainer;
